<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <div class="grid">
    <div class="col-12">
      <p-card styleClass="very-compact-card p-3">
        <div class="formgrid grid">
          <div class="field col-12">
            <label class="font-medium required-field">Название</label>
            <crm-input-text
              [(value)]="form.name"
              class="w-full"
              [isError]="$any(errors?.name)"></crm-input-text>
            <small
              *ngIf="errors?.name"
              class="p-error">
              {{ errors.name | join }}
            </small>
          </div>

          <div class="field-checkbox col-12">
            <p-checkbox
              [ngModel]="form.measure === '%'"
              (onChange)="togglePercent()"
              [binary]="true"
              inputId="measure"></p-checkbox>
            <label [for]="'measure'">Процент</label>
          </div>

          <div class="field-checkbox col-12 mb-0">
            <p-checkbox
              [ngModel]="form.color === '#F4F4F5'"
              (onChange)="toggleColor()"
              [binary]="true"
              inputId="color"></p-checkbox>
            <label [for]="'color'">Выделять в отчете</label>
          </div>
        </div>
      </p-card>

      <p-card styleClass="mt-3 very-compact-card p-3">
        <h3 class="m-0 required-field">Формула</h3>
        <p-messages severity="info">
          <ng-template pTemplate="">
            <div class="flex gap-3">
              <i
                class="pi pi-exclamation-circle mt-1"
                style="font-size: 1.3rem"></i>
              <div>
                <p>
                  Введите формулу, по которой будет считаться
                  {{ form.name?.length ? '"' + form.name + '"' : 'Фин. показатель' }}.
                </p>
                <p>
                  Для добавления в формулу значение из БС или Фин.показателей, нужно нажать на кнопку {{ '"{x}"' }}.
                </p>
                <p class="mt-2">Доступные математические операции: + - * /</p>
                <p>Доступные сложные выражения с учетом скобок.</p>
              </div>
            </div>
          </ng-template>
        </p-messages>

        <div class="p-fluid">
          <div class="field">
            <div class="p-inputgroup">
              <crm-input-text
                #expressionInput
                [(value)]="form.expression"
                (valueChange)="parseExpression()"
                class="w-full"
                placeholder="50000 * (100 / 50)"
                [isError]="$any(errors?.expression)"
                (contextmenu)="opExpression.toggle($event); $event.preventDefault()"
                (keydown.escape)="keydownEscInExpressionInput($any($event))"></crm-input-text>
              <button
                type="button"
                pButton
                label="{x}"
                (click)="opExpression.toggle($event)"></button>
            </div>
            <p
              *ngIf="resultExpression?.length"
              class="my-2">
              {{ resultExpression }}
            </p>
            <small
              *ngIf="errors?.expression"
              class="p-error">
              {{ errors.expression | join }}
            </small>
          </div>
        </div>
      </p-card>
    </div>
  </div>

  <div class="grid mt-3">
    <div class="col-12 flex flex-wrap justify-content-between">
      <button
        pButton
        [label]="saveButtonLabel"
        class="p-button-success mr-2"
        (click)="saveItem()"></button>
      <button
        *ngIf="(form$ | async)?.isEdit"
        pButton
        label="Удалить"
        class="p-button-danger p-button-text"
        (click)="deleteCustomRow()"></button>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>

<p-overlayPanel
  #opExpression
  [style]="{ width: '200px' }"
  (onShow)="isShowOverlayPanel = true"
  (onHide)="isShowOverlayPanel = false"
  styleClass="dropdown-overlay-panel">
  <ng-template pTemplate="">
    <p-tree
      [value]="customRows | orderBy: 'label:string'"
      (onNodeSelect)="selectCustomRow($event.node); opExpression.hide()"
      [filter]="true"
      selectionMode="single"
      scrollHeight="250px"
      [style]="{ 'max-height': '300px' }"
      styleClass="compact-list"></p-tree>
  </ng-template>
</p-overlayPanel>
